import { useEffect, useState } from "react";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { providerService } from "../../_services/provider.service";

export function QuoteProviderLogoView(params: { providerId: number | null }) {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();


    useEffect(() => {
        if (!params.providerId) return;
        fetchData();
    }, [params.providerId]);

    function fetchData() {
        if (!params.providerId) return;
        setIsLoading(true)
        return providerService
            .getLogo(params.providerId)
        //    .then(
        //        (json) => {
        //            setData(json);
        //        }
        //)
            .then(
                (json) => {
                    setData(json);
                },
                (e) => { handleErrorResponse(e) })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            {data &&
                <img id="logoImg" style={{
                    width: "90%",
                    marginTop: "0px",
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: "0px"
                }} src={"data:image/jpeg;charset=utf-8;base64," + data} alt={"Provider Logo"}></img>
            }
        </>
    );

}
